<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

/* ============================================================================= */
/* Upcart Cart Drawer accessibility/performance patch                            */
/* Added by Karin's Lighthouse fix pass (see conversation with Claude).          */
/* Upcart renders its cart drawer inside an open Shadow DOM on #upCart, and its  */
/* own markup is missing a few things Lighthouse flags: image width/height,     */
/* an id/name on the quantity input, aria-labels on the "remove item" button    */
/* and the upsell variant <select>, and it duplicates the "go to product" link  */
/* (once as a bare image link, once as the visible title) which trips the      */
/* "identical links" and "no discernible name" checks. Since Upcart doesn't     */
/* expose settings for any of this, this script patches the DOM after Upcart    */
/* renders it, every time the drawer's content changes, via a MutationObserver. */
/* This targets Upcart's own "upcart-*" class names, which are more stable than */
/* its CSS-module hashed style classes, but if Upcart ships a markup change     */
/* this may need revisiting.                                                    */
/* ============================================================================= */
(function () {
    'use strict';

    function safeSetAttr(el, attr, value) {
        if (!el.hasAttribute(attr)) el.setAttribute(attr, value);
    }

    function patchImage(img) {
        if (img.hasAttribute('width') && img.hasAttribute('height')) return;

        var applyDimensions = function () {
            if (img.hasAttribute('width') && img.hasAttribute('height')) return;
            if (img.naturalWidth && img.naturalHeight) {
                safeSetAttr(img, 'width', img.naturalWidth);
                safeSetAttr(img, 'height', img.naturalHeight);
                return;
            }
            var rect = img.getBoundingClientRect();
            var w = Math.round(rect.width) || 80;
            var h = Math.round(rect.height) || 80;
            safeSetAttr(img, 'width', w);
            safeSetAttr(img, 'height', h);
        };

        if (img.complete) {
            applyDimensions();
        } else {
            img.addEventListener('load', applyDimensions, { once: true });
            applyDimensions();
        }
    }

    function findNearbyTitle(el) {
        var container = el.closest('[class*="upsell-item" i], [class*="ProductRow" i], [class*="product-row" i]');
        if (!container) return '';
        var titleEl = container.querySelector('a');
        return titleEl ? (titleEl.textContent || '').trim() : '';
    }

    function patchRoot(root) {
        if (!root || !root.querySelectorAll) return;

        // 1. Images missing width/height (product thumbnails, upsell carousel images)
        root.querySelectorAll('img:not([width]), img:not([height])').forEach(patchImage);

        // 2. Quantity inputs missing an id/name for autofill/labelling purposes
        root.querySelectorAll('input[class*="quantity-input" i]').forEach(function (input, i) {
            if (!input.getAttribute('name')) input.setAttribute('name', 'upcart-quantity');
            if (!input.id) input.id = 'upcart-quantity-input-' + i;
        });

        // 3. "Remove item" trash button has no accessible name
        root.querySelectorAll('[class*="TrashButton" i]').forEach(function (btn) {
            if (!btn.getAttribute('aria-label')) {
                if (!btn.hasAttribute('role')) btn.setAttribute('role', 'button');
                btn.setAttribute('aria-label', 'Remove item');
            }
        });

        // 4. Upsell carousel duplicates the product link: one bare image link with
        // no text, one with the visible title. Hide the redundant, unlabelled one
        // from assistive tech rather than guessing a label, since the titled link
        // right next to it already provides the accessible way to reach the product.
        root.querySelectorAll('[class*="upsell-item-image-wrapper" i] a, a[class*="upsell-item-image-wrapper" i]').forEach(function (a) {
            var hasText = (a.textContent || '').trim().length > 0;
            if (!hasText && !a.getAttribute('aria-label')) {
                a.setAttribute('aria-hidden', 'true');
                a.setAttribute('tabindex', '-1');
            }
        });

        // 5. Upsell variant <select> has no accessible name
        root.querySelectorAll('select[name="productVariant"]').forEach(function (sel) {
            if (!sel.getAttribute('aria-label')) {
                var title = findNearbyTitle(sel);
                sel.setAttribute('aria-label', title ? ('Select variant for ' + title) : 'Select product variant');
            }
        });
    }

    function watchCartDrawer() {
        var host = document.getElementById('upCart');
        if (!host) {
            setTimeout(watchCartDrawer, 500);
            return;
        }

        var attach = function () {
            if (!host.shadowRoot) return false;
            patchRoot(host.shadowRoot);
            var observer = new MutationObserver(function () {
                patchRoot(host.shadowRoot);
            });
            observer.observe(host.shadowRoot, { childList: true, subtree: true });
            return true;
        };

        if (!attach()) {
            var tries = 0;
            var poll = setInterval(function () {
                tries++;
                if (attach() || tries > 40) clearInterval(poll);
            }, 250);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', watchCartDrawer);
    } else {
        watchCartDrawer();
    }
})();
